import * as moment from 'moment';

export function customDateFormat(d) {
  let year = moment(d).format('YYYY');
  return `${year}`;
}

export function customMobileDateFormat(d, i) {
  let month = moment(d).format('MMM'),
    year = moment(d).format('YYYY');

  if (i % 2 == 0) return `${year}`;
  else return '';
}
